import React from 'react';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { services } from '../data/mock';

const Servizi = () => {
  return (
    <div className="servizi-page">
      {/* Hero */}
      <section className="page-hero">
        <div className="container">
          <h1 className="display-title">I Nostri <span className="text-brand-red">Servizi</span></h1>
          <div className="accent-line"></div>
          <p className="body-large text-secondary" style={{ maxWidth: '800px', marginTop: '1.5rem' }}>
            Soluzioni complete di segnaletica stradale e industriale per ogni settore
          </p>
        </div>
      </section>

      {/* Services List */}
      <section className="section">
        <div className="container">
          <div className="services-list">
            {services.map((service, idx) => (
              <div key={service.id} className="service-item">
                <div className="service-number">{String(idx + 1).padStart(2, '0')}</div>
                <div className="service-content">
                  <h2 className="service-title">{service.title}</h2>
                  <p className="service-description">{service.description}</p>
                  <div className="service-features-grid">
                    {service.features.map((feature, fidx) => (
                      <div key={fidx} className="service-feature-item">
                        <CheckCircle size={18} className="feature-check-icon" />
                        <span>{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="section section-blue-tint">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Vantaggi per i Clienti</h2>
            <div className="accent-line"></div>
          </div>

          <div className="benefits-grid">
            <div className="benefit-card card">
              <h3 className="benefit-title">Servizio Completo</h3>
              <p className="benefit-description">
                Dalla consulenza tecnica alla manutenzione post-intervento, gestiamo ogni fase del progetto.
              </p>
            </div>
            <div className="benefit-card card">
              <h3 className="benefit-title">Materiali Certificati</h3>
              <p className="benefit-description">
                Utilizziamo esclusivamente materiali certificati e tecnologie all'avanguardia per garantire durabilità.
              </p>
            </div>
            <div className="benefit-card card">
              <h3 className="benefit-title">Conformità Normativa</h3>
              <p className="benefit-description">
                Ogni intervento rispetta le normative vigenti in materia di sicurezza e segnaletica.
              </p>
            </div>
            <div className="benefit-card card">
              <h3 className="benefit-title">Esperienza Comprovata</h3>
              <p className="benefit-description">
                Collaboriamo con i più grandi nomi della logistica, GDO e retail in tutta Italia.
              </p>
            </div>
            <div className="benefit-card card">
              <h3 className="benefit-title">Tempi Rapidi</h3>
              <p className="benefit-description">
                Team qualificato e attrezzature professionali per interventi veloci ed efficienti.
              </p>
            </div>
            <div className="benefit-card card">
              <h3 className="benefit-title">Assistenza Continua</h3>
              <p className="benefit-description">
                Supporto post-intervento e servizi di manutenzione per garantire la durata nel tempo.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section">
        <div className="container">
          <div className="cta-box">
            <h2 className="section-title" style={{ textAlign: 'center' }}>
              Hai Bisogno di un Servizio Specifico?
            </h2>
            <p className="body-large text-secondary" style={{ textAlign: 'center', marginTop: '1.5rem', maxWidth: '600px', marginLeft: 'auto', marginRight: 'auto' }}>
              Contattaci per discutere le tue esigenze e ricevere un preventivo personalizzato
            </p>
            <div style={{ textAlign: 'center', marginTop: '2.5rem' }}>
              <Link 
                to="/contatti" 
                className="btn-primary"
                onClick={() => {
                  setTimeout(() => window.scrollTo(0, 0), 100);
                }}
              >
                Richiedi Preventivo
                <ArrowRight size={20} />
              </Link>
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        .servizi-page {
          padding-top: 80px;
        }

        .page-hero {
          padding: var(--space-xl) 0 var(--space-lg);
          background: var(--bg-page);
        }

        .section-header {
          text-align: center;
          margin-bottom: var(--space-lg);
        }

        /* Services List */
        .services-list {
          display: flex;
          flex-direction: column;
          gap: var(--space-lg);
        }

        .service-item {
          display: grid;
          grid-template-columns: 120px 1fr;
          gap: var(--space-md);
          background: var(--bg-card);
          border: 1px solid var(--border-light);
          padding: var(--space-lg);
          transition: all 0.3s ease;
        }

        .service-item:hover {
          border-color: var(--brand-orange);
          background: var(--bg-card-hover);
        }

        @media (max-width: 768px) {
          .service-item {
            grid-template-columns: 1fr;
            gap: var(--space-sm);
          }
        }

        .service-number {
          font-size: 5rem;
          font-weight: 900;
          color: var(--brand-orange);
          line-height: 1;
          opacity: 0.2;
        }

        @media (max-width: 768px) {
          .service-number {
            font-size: 3rem;
          }
        }

        .service-content {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .service-title {
          font-size: 2rem;
          font-weight: 800;
          color: var(--text-primary);
          text-transform: uppercase;
        }

        .service-description {
          color: var(--text-secondary);
          font-size: 1.125rem;
          line-height: 1.7;
        }

        .service-features-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 1rem;
        }

        @media (max-width: 640px) {
          .service-features-grid {
            grid-template-columns: 1fr;
          }
        }

        .service-feature-item {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          color: var(--text-secondary);
          font-size: 0.95rem;
        }

        .feature-check-icon {
          color: var(--brand-orange);
          flex-shrink: 0;
        }

        /* Benefits */
        .benefits-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: var(--space-md);
          margin-top: var(--space-lg);
        }

        @media (max-width: 1024px) {
          .benefits-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 640px) {
          .benefits-grid {
            grid-template-columns: 1fr;
          }
        }

        .benefit-card {
          padding: var(--space-md);
          text-align: center;
        }

        .benefit-title {
          font-size: 1.5rem;
          font-weight: 700;
          color: var(--text-primary);
          margin-bottom: 1rem;
        }

        .benefit-description {
          color: var(--text-secondary);
          line-height: 1.6;
          font-size: 0.95rem;
        }

        /* CTA */
        .cta-box {
          background: var(--bg-card);
          border: 2px solid var(--brand-blue);
          padding: var(--space-lg);
          border-radius: 1rem;
        }
      `}</style>
    </div>
  );
};

export default Servizi;
